import { REMOVE_IMMUNIZATIONS, SET_IMMUNIZATIONS, ADD_IMMUNIZATION } from './types'

const immunizations = (state = [], action) => {
  switch (action.type) {
    case SET_IMMUNIZATIONS:
      return action.payload
    case REMOVE_IMMUNIZATIONS:
      return []
    case ADD_IMMUNIZATION:
      state.push(action.payload)
      return state
    // BE ADVISED: This immunizations state is a complete fuck up (!!!!), the immunizations should not be separate from the patient state
    // const immunizations = state
    // let newArray = immunizations.slice()
    // newArray.splice(immunizations.length, 0, action.payload)
    // return newArray
    default:
      return state
  }
}
export default immunizations
